import { differenceInDays, isValid } from 'date-fns';

export const getProjectDurationWeeks = ({
  startDate,
  endDate,
}: {
  startDate?: string | Date | null;
  endDate?: string | Date | null;
}) => {
  if (!startDate || !endDate) {
    return null;
  }

  const projectStartDate = new Date(startDate);
  const projectEndDate = new Date(endDate);

  if (!isValid(projectStartDate) || !isValid(projectEndDate)) {
    return null;
  }

  return differenceInDays(projectEndDate, projectStartDate) / 7;
};
